import React from 'react';
import PropTypes from 'prop-types';
import { Carousel, Icon } from 'antd';
import Button from 'components/Button';
import { slugify } from 'common/helpers';
import { getTextRating, getPercentage, renderStars, renderPerfectFor, formatXMoney } from './../helpers';
import { Hotel as S } from './../styles';

class Hotel extends React.Component {
  next = () => this.slider.next();
  prev = () => this.slider.prev();
  handleClick = (hotel) => {
    this.props.modal(true);
    this.props.selectedHotel(hotel);
  }
  renderNoPrice = () => {
    return (
      <div>
        <h3 className="price">
          <strong>Price on enquiry</strong>
        </h3>
        <div className="save">
          <label>Exclusive SWC Rates</label>
        </div>
      </div>
    );
  }
  renderPrice = (price, origPrice, notes) => {
    return (
      <div>
        <h3 className="price">
          <small>From:</small>
          <strong>THB {formatXMoney(notes, 'XXX')} (~${formatXMoney(price, 'XX')}+)<span className="asterisk">*</span></strong>
        </h3>
        <div className="save">
          <label>SAVE UP TO {getPercentage(origPrice, price)}%</label>
          <span>~${formatXMoney(origPrice, 'XXX')}</span>
        </div>
      </div>
    );
  }
  render() {
    const {
      hotel: {
        images,
        name,
        desc,
        distance,
        stars,
        rating,
        price,
        notes,
        perfectFor,
        priceOnEnquiry,
      },
    } = this.props;
    const origPrice = this.props.hotel.strike_through_price;
    return (
      <S.Wrapper id={slugify(name)}>
        <S.Slider>
          <button onClick={this.prev} className="btn left"><Icon type="arrow-left" /></button>
          <button onClick={this.next} className="btn right"><Icon type="arrow-right" /></button>
          {!priceOnEnquiry && (<div className="save">Save {getPercentage(origPrice, price)}%</div>)}
          <Carousel
            autoplay={true}
            dots={true}
            autoplaySpeed={5000}
            ref={(ref) => { this.slider = ref; }}
          >
            {images ? images.map((image) => (
              <div key={image.toString()}>
                <div
                  className="bgSlide"
                  style={{ backgroundImage: `url(${image})` }}
                />
              </div>
            )) : null }
          </Carousel>
        </S.Slider>
        <S.InfoPrices>
          <S.Info>
            <h3><span>{name}</span> { renderStars(stars)}</h3>
            {renderPerfectFor(perfectFor)}
            <p>Distance to venue: {distance < 100 ? (`${distance}-min walk`) : 'varies'}</p>
            <p style={{ margin: 0 }}>{desc}</p>
          </S.Info>
          <S.Prices>
            <div className="rating">
              <p><strong>Rating:</strong><br />{getTextRating(rating)}</p>
              <h5>{rating}</h5>
            </div>
            {priceOnEnquiry ? this.renderNoPrice() : this.renderPrice(price, origPrice, notes) }
            <Button size="1.6em" padding="10px 30px" onClick={() => this.handleClick(this.props.hotel)} className="btnView" data-hotel-name={name}>See <span data-hotel-name={name}>Discounted</span> Rooms</Button>
            <p style={{ fontSize: '1.2em', marginTop: '10px' }}><i>* Pricing approximate and subject to exchange rates.<br />You will pay in the hotel&apos;s local currency (THB).</i></p>
          </S.Prices>
        </S.InfoPrices>
      </S.Wrapper>
    );
  }
}

Hotel.propTypes = {
  modal: PropTypes.func.isRequired,
  hotel: PropTypes.object.isRequired,
  selectedHotel: PropTypes.func.isRequired,
};

export default Hotel;



// WEBPACK FOOTER //
// ./src/containers/Hotel/PartnerHotels/Hotel.js